import type {OwnerDayCloseReadModel} from '../../contracts/owner-dayclose-v1';
export type DayCloseView={status:'LOADING'|'READY'|'ERROR';selectedDate:string|null;dates:readonly string[];value:OwnerDayCloseReadModel|null;previous:OwnerDayCloseReadModel|null};
/** Request identity only; no caching authority or business polling. */
export function createDayCloseReader(read:(date?:string)=>Promise<OwnerDayCloseReadModel>,changed:(view:DayCloseView)=>void,preferredDate?:string){
  let sequence=0,last:OwnerDayCloseReadModel|null=null;
  let view:DayCloseView={status:'LOADING',selectedDate:null,dates:[],value:null,previous:null};
  const update=(next:Partial<DayCloseView>)=>{view={...view,...next};changed(view);};
  async function load(date?:string){
    const request=++sequence;update({status:'LOADING',selectedDate:date??null,value:null,previous:last});
    try{const next=await read(date);if(request!==sequence)return;
      // Selected-date responses only contain that day; preserve the bounded
      // discovery list so changing dates does not collapse the selector.
      update({dates:date?[...new Set([...view.dates,...next.availableDates])].sort().reverse():next.availableDates});
      if(!date&&(preferredDate||next.availableDates[0])){await load(preferredDate??next.availableDates[0]);return;}
      last=next;update({status:'READY',selectedDate:next.businessDate,value:next,previous:null});
    }catch{if(request===sequence)update({status:'ERROR',value:null});}
  }
  return {load,retry:()=>load(view.selectedDate??undefined),stop:()=>{sequence++;},snapshot:()=>view};
}
export function dayCloseMoney(value:unknown){return typeof value==='number'&&Number.isSafeInteger(value)?'HK$'+(value/100).toLocaleString('en-HK',{minimumFractionDigits:2,maximumFractionDigits:2}):'未記錄';}
/** R1-12：營業額對照用 "$58" 格式；冇資料就寫「未有」，唔當 0。 */
export function dayCloseDollar(value:unknown){
  if(typeof value!=='number'||!Number.isSafeInteger(value))return '未有';
  const abs=Math.abs(value)/100;
  return (value<0?'-':'')+'$'+(Number.isInteger(abs)?String(abs):abs.toFixed(2));
}
/** 雲端淨額用 Owner 已讀到嘅正式日報（同一份 projectionReports），伺服器唔使再掃全部訂單。 */
export function withCloudNet(sales:OwnerDayCloseReadModel['sales'],cloudNetMinor:number|null|undefined):OwnerDayCloseReadModel['sales']{
  if(!sales)return sales;
  const cloud=sales.cloudNetMinor??(typeof cloudNetMinor==='number'&&Number.isSafeInteger(cloudNetMinor)?cloudNetMinor:null);
  return {...sales,cloudNetMinor:cloud,differenceMinor:sales.padNetMinor!==null&&cloud!==null?sales.padNetMinor-cloud:null};
}
export function dayCloseSalesLines(sales:OwnerDayCloseReadModel['sales']){
  if(!sales)return null;
  const diff=sales.differenceMinor;
  return {
    rows:[['Pad 日結總額',dayCloseDollar(sales.padGrossMinor)],['Pad 日結退款',dayCloseDollar(sales.padRefundMinor)],['Pad 日結淨額',dayCloseDollar(sales.padNetMinor)],['雲端報表淨額',dayCloseDollar(sales.cloudNetMinor)]] as const,
    difference:diff===null?(sales.padNetMinor===null?'Pad 呢次日結冇封存營業額，對唔到數':'雲端未有呢日報表，對唔到數'):diff===0?'兩邊一樣，冇差額':'相差 '+dayCloseDollar(diff)+'（Pad 減雲端）',
    matched:diff===0,
  };
}
